
import initCheckoutTimer from '../components/init-checkout-timer.js'
import { __sendVisit, __visit } from '../components/send-visit.js'

import { barbaMarkup, getTicketEid, initValidation } from '../utils/func.js'

import { getEmailFromCookie } from './fast-payment.js'
import { btnLoadingDone, btnLoadingStart } from '../components/loading.js'
import { bake_cookie, getCookie } from '../utils/cookie.js'
import { catchEmail, catchMListOptIn, getMlistVal } from '../utils/catch-email.js'
import '../utils/on-input-key.js'
import '../utils/on-input-click.js'
// import getUrlParameter from '../utils/get-url-parameter'
import { gatherDataAndCheck, suggestedMessage } from '../components/check-email.js'

// import { triggerMatomo } from '../components/trigger-matomo'
import getUrlParameter from '../utils/get-url-parameter.js'
import { saveGeolocation } from '../components/getGeolocation.js'

const savedEmailObj = {}
let gatherDataAndCheckisDone = false

export const EnterEmail = {
	namespace: 'enterEmail',
	beforeEnter(data) {
		barbaMarkup('enterEmail')
		setEmailValidationRules()
		getEmailFromCookie('#enter-email-input')
		catchEmail('#enter-email-input')
		catchMListOptIn('#mailingListOptIn')
		initCountDownMobile()
	},
	afterEnter() {
		getTicketEid()
		bake_cookie('seatsInCartObj', window.seatsInCartObj, 1)
		window.scrollTo(0, 0)
		trackMailingListOptInCheckBox()
		__sendVisit()
		// triggerMatomo(window.myvars.scheduleEid, 'enterEmail')
		saveGeolocation()
	},
}

export function setEmailValidationRules() {
	const form = '.enter-email-wrapper'
	const rulesObj = {
		'email-capture': {
			required: true,
			email: true,
		},
	}
	const messagesObj = {
		'email-capture': window.myvars.emailCapture,
		// email: myvars.email
		// subject: myvars.seatSelectionsEmailSubject
	}
	initValidation(form, rulesObj, messagesObj)
}

async function testEmail() {
	try {
		await btnLoadingStart('#fastPaymentNextButton')
		await getMlistVal('#mailingListOptIn')
		// trackMailingListOptInCheckBox()
		if ($('.enter-email-wrapper').valid()) {
			const result = await gatherDataAndCheck()
			if (gatherDataAndCheckisDone) {
				await btnLoadingStart('#fastPaymentNextButton')
				await console.info('Email is Not Correct')
				window.location.href = '/store/order/review-cart'
			} else if (result !== '') {
					gatherDataAndCheckisDone = true
					await suggestedMessage()
					await btnLoadingDone('#fastPaymentNextButton')
					await console.info('fixedEmail is done')
				} else {
					await console.info('Email is NP')
					window.location.href = '/store/order/review-cart'
				}

			// await barba.go('/store/order/review-cart')
		} else {
			btnLoadingDone('#fastPaymentNextButton')
		}
	} catch (e) {
		console.info(`testEmail is catch by ${e}`)
	}
}


function initCountDownMobile() {
	// giftCardCheckout = !!(getCookie('giftCardCheckout'))
	giftCardCheckout = getCookie('giftCardCheckout')

	if (!giftCardCheckout) {
		$('.mobile-header-timer').addClass('flex')
		const countDownSeconds = $('#enter-email-countdown-seconds').attr(
			'data-countdown'
		)
		const {alertMessage} = window.myvars
		initCheckoutTimer(countDownSeconds, alertMessage, false)
	}
}

export function trackMailingListOptInCheckBox() {
	console.debug('mailingListOptIn')
	if ($('#mailingListOptIn').attr('tracking-enable') == '1') {
		const params = JSON.parse($('#mailingListOptIn').attr('tracking-data'))
		if ($('#mailingListOptIn').attr('type') == 'checkbox') {
			params.value = $('#mailingListOptIn').is(':checked') ? 'in' : 'out'
			__visit(params)
			console.debug(`mailingListOptIn->type-checkbox: ${params.value}`)
		} else if ($('#mailingListOptIn').attr('type') == 'hidden') {
			params.value = $('#mailingListOptIn').val() == '1' ? 'in' : 'out'
			__visit(params)
			console.debug(`mailingListOptIn->type-hidden: ${params.value}`)
		}
	}
}

// window.goBackTarget = goBackTarget
window.testEmail = testEmail
window.trackMailingListOptInCheckBox = trackMailingListOptInCheckBox
